import type { NotificationVo, NotificationInfo, NotificationOperationParams } from "@zhihaoscm/entity";
import type { Page } from "../../../../common/types/base/BaseEntity";
import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";
import { READ_STATE, ADMIN_PUBLISH_PLAT } from "@zhihaoscm/meta";

export class NotificationService extends BaseService<
    NotificationInfo,
    NotificationVo,
    NotificationOperationParams,
    any
> {
    /**
     * 分页查询
     */
    async paging(params: { page: number; size: number }): Promise<Page<NotificationVo>> {
        const { data } = await this.service.get(this.path + "/paging", { params });
        return data;
    }

    /**
     * 对单通知的已读
     */
    async read(params: { notificationIds?: number[] }) {
        const notificationParams: NotificationOperationParams = {
            notificationIds: params.notificationIds,
            readState: READ_STATE.READ.code,
            all: false
        };
        await this.service.post(this.path + "/customReadOrDelete", notificationParams);
    }

    /**
     * 批量已读
     */
    async batchReaded(params: { notificationIds: number[] }) {
        const notificationParams: NotificationOperationParams = {
            notificationIds: params.notificationIds,
            readState: READ_STATE.READ.code,
            all: true
        };
        await this.service.post(this.path + "/customReadOrDelete", notificationParams);
    }

    /**
     * 批量删除
     */
    async batchDel(params: { notificationIds?: number[] }) {
        const notificationParams: NotificationOperationParams = {
            notificationIds: params.notificationIds,
            readState: READ_STATE.DELETED.code,
            all: false
        };
        await this.service.post(this.path + "/customReadOrDelete", notificationParams);
    }

    /**
     * 全部删除
     */
    async allDel() {
        const notificationParams: NotificationOperationParams = {
            readState: READ_STATE.DELETED.code,
            all: true
        };
        await this.service.post(this.path + "/customReadOrDelete", notificationParams);
    }

    /**
     * 全部已读
     */
    async allRead() {
        const notificationParams: NotificationOperationParams = {
            readState: READ_STATE.READ.code,
            all: true
        };
        await this.service.post(this.path + "/customReadOrDelete", notificationParams);
    }

    /**
     * 通知详情
     * @params id 通知id
     */
    async getDetail(id: number): Promise<NotificationInfo> {
        const { data } = await this.service.get(`${this.path}/${id}`);
        return data;
    }

    /**
     * 未读消息数量
     */
    async getMsgNum(): Promise<{ unread: number }> {
        const { data } = await this.service.post(this.path + "/getUnreadNotificationCount/count", {
            onPlat: ADMIN_PUBLISH_PLAT.SAND_PC.code
        });
        return data;
    }
}

export const notificationService = new NotificationService("/notification", httpRequest);
